import { X } from "lucide-react";
import rightmark from "../../../../assets/right-mark-with-background.png";

const rightMarkeImg = <img src={rightmark} className="w-5 h-5" alt="right mark" />;

const getPlanIndex = (btnValue) => {
  switch (btnValue) {
    case "base": return 0;
    case "premium": return 1;
    case "premiumplus": return 2;
    case "ultimate": return 3;
    default: return 0;
  }
};

const getPlanValue = (values, planIndex) => {
  if (!values || values.length === 0) return "";
  if (planIndex >= values.length) return "";
  const value = values[planIndex];
  if (value && typeof value === "object" && (value.type === "img" || value.$$typeof)) return "check";
  if (value === "✓") return "check";
  if (value === "✗" || value === "x") return "x";
  return value?.toString() || "";
};

const freeBusinessFeatures = [
  { name: "business chat - open customer engagement",              values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "in-chat ordering (continuous ordering - pay anytime)", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "in-chat cancellations and refunds",                    values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "order capacity and q management",                      values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "customisable ordering flows",                          values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "hybrid ordering - team members and customers",         values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "click and collect",                                    values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "customer chat prioritisation",                         values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "physical/static & mobile locations",                   values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "multi location management",                            values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "ratings and reviews",                                  values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const freeAIFeature = [
  { name: "in-chat ai customer support",  values: ["up to 200k msgs", "up to 200k msgs", "up to 200k msgs", "up to 200k msgs"] },
  { name: "ai order recommendations",     values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "ai booking & reservations",    values: ["coming soon", "coming soon", "coming soon", "coming soon"] },
];

const freePaymentSolutions = [
  { name: "business wallet per location",    values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital invoices and receipts",   values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "group ordering and payments",     values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const geoMarketingSolutions = [
  { name: "digital storefront per location",                    values: ["1", "3", "6", "10"] },
  { name: "full market place access",                           values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "digital menus & digital catalogues",                 values: ["2", "10", "20", "40"] },
  { name: "team association and visibility",                    values: ["5", "60", "150", "200"] },
  { name: "social media, posting (per month)",                  values: ["10", "100", "300", "500"] },
  { name: "likes, following and sharing",                       values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "group chats",                                        values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "events (per month)",                                 values: ["5", "25", "60", "150"] },
  { name: "fast marketing via posts and text (additional fee)", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "marketing and engagement insights",                  values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const freeInventSolutions = [
  { name: "menu's and catalogues per location, timed", values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "item inventory per location",               values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "item scanner",                              values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
  { name: "inventory dashboard",                       values: [rightMarkeImg, rightMarkeImg, rightMarkeImg, rightMarkeImg] },
];

const cardStyle = {
  backgroundColor: "rgba(26,26,26,0.8)",
  border: "1px solid rgba(112,0,255,0.2)",
  borderRadius: "32px",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  overflow: "hidden",
};

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="10" cy="10" r="10" fill="#D1BCFF" />
    <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#1A0A2E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PricingNavContentPage2 = (props) => {
  const planIndex = getPlanIndex(props.btnContentValue);

  const toRows = (arr) => arr.map(item => ({
    label: item.name,
    value: getPlanValue(item.values, planIndex),
  }));

  const sections = [
    { title: "free business features",   rows: toRows(freeBusinessFeatures) },
    { title: "free ai features",          rows: toRows(freeAIFeature) },
    { title: "free payment solutions",    rows: toRows(freePaymentSolutions) },
    { title: "geo marketing solutions",   rows: toRows(geoMarketingSolutions) },
    { title: "free inventory solutions",  rows: toRows(freeInventSolutions) },
  ];

  return (
    <div className="w-full" style={{ backgroundColor: "#020013" }}>
      <div className="w-full px-4 md:px-12 lg:px-20 xl:px-28 pt-8 md:pt-20 pb-20">

        {/* choose a package heading */}
        <h2
          className="lowercase text-center mb-6"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: "clamp(28px, 7vw, 56px)", lineHeight: "100%", letterSpacing: "-0.04em" }}
        >
          <span style={{ color: "#9747FF" }}>choose a package </span>
          <span style={{
            background: "linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0.7) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}>
            that fits your business
          </span>
        </h2>

        <p
          className="lowercase text-center mx-auto mb-16"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(16px, 4vw, 28px)", lineHeight: "140%", letterSpacing: "-0.04em", color: "#FFFFFF", maxWidth: "1200px" }}
        >
          free no risk 30 day trial. cancel anytime. serve more, spend less with chat ordering that works for you.
        </p>

        {/* it's all in the details */}
        <h3
          className="lowercase text-center mb-14"
          style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "clamp(28px, 7vw, 56px)", lineHeight: "1.1", letterSpacing: "-0.8px" }}
        >
          <span style={{ color: "#FFFFFF" }}>it's all in </span>
          <span style={{ color: "#9747FF" }}>the details</span>
        </h3>

        {/* Feature sections */}
        <div className="flex flex-col" style={{ gap: "60px" }}>
          {sections.map(({ title, rows }) => (
            <div key={title}>
              {/* Section label */}
              <p
                className="lowercase mb-5"
                style={{ fontFamily: "Inter, sans-serif", fontWeight: 500, fontSize: "clamp(18px, 4.5vw, 24px)", lineHeight: "1.4", letterSpacing: "0px", color: "#721AF0", paddingLeft: "15px" }}
              >
                {title}
              </p>

              {/* Section card */}
              <div style={cardStyle}>
                {rows.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between min-h-[68px] md:min-h-[81px]"
                    style={{
                      paddingLeft: "24px",
                      paddingRight: "24px",
                      borderTop: i > 0 ? "1px solid #4A445733" : "none",
                    }}
                  >
                    <span
                      className="lowercase"
                      style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(15px, 4vw, 20px)", lineHeight: "1.4", letterSpacing: "0px", color: "#FFFFFF" }}
                    >
                      {item.label}
                    </span>

                    <span className="flex items-center ml-4" style={{ flexShrink: 0 }}>
                      {item.value === "check" ? (
                        <CheckIcon />
                      ) : item.value === "x" ? (
                        <X size={18} style={{ color: "rgba(255,255,255,0.3)" }} />
                      ) : item.value ? (
                        <span style={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 400,
                          fontStyle: item.value === "coming soon" ? "italic" : "normal",
                          fontSize: "16px",
                          lineHeight: "24px",
                          letterSpacing: "0px",
                          color: item.value === "coming soon" ? "#D1BCFF" : "#CCC3DA",
                          textAlign: "right",
                          whiteSpace: "nowrap",
                        }}>
                          {item.value}
                        </span>
                      ) : null}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingNavContentPage2;
